import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useContext, useMemo } from "react";
import { DialogProvider, createDialogContext } from "../../../Common/Dialog";
import { KYDTicketType } from "@common/interfaces/KYDTicket";
import { TicketTypeTier } from "./TieredTicketType/schema";

export const DeleteTierDialogContext = createDialogContext();

const DeleteTierDialog = ({
  onDelete,
  onClose,
  ticketType,
  isLoading = false,
}: {
  ticketType: TicketTypeTier;
  isLoading: boolean;
  onClose: () => void;
  onDelete: (id: string) => Promise<void>;
}) => {
  const { isOpen } = useContext(DeleteTierDialogContext);

  const _onClose = () => {
    onClose();
  };

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={_onClose}
        isCentered
      >
        <ModalOverlay />
        <ModalContent
          mb={[0, "auto"]}
          borderBottomLeftRadius={[0, "md"]}
          borderBottomRightRadius={[0, "md"]}
        >
          <ModalHeader paddingTop={4}>
            <VStack gap={0} width={"full"}>
              <Text w="full">Delete tier {ticketType?.name}</Text>
            </VStack>
          </ModalHeader>
          <ModalBody textAlign={"left"}>
            <VStack w="full">
              <Text w="full">
                Are you sure you want to delete tier {ticketType?.name}?
              </Text>
              <Text color="red.500" w="full">
                This action can not be undone.
              </Text>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Stack direction={["column-reverse", "row-reverse"]} width="100%">
              <Button
                key={"delete"}
                bg="red.500"
                color="white"
                w={"auto"}
                isLoading={isLoading}
                isDisabled={isLoading}
                onClick={() => onDelete(ticketType?.id)}
              >
                Delete tier
              </Button>
              <Button
                key={"cancel"}
                isLoading={isLoading}
                isDisabled={isLoading}
                w={"auto"}
                onClick={_onClose}
              >
                Cancel
              </Button>
            </Stack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export const withDeleteTierDialog =
  <T extends object>(Component: React.ComponentType<T>) =>
  (props: T) => {
    return (
      <DialogProvider context={DeleteTierDialogContext}>
        <Component {...(props as T)} />
      </DialogProvider>
    );
  };

export default DeleteTierDialog;
